import React, { useState } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Area,
  AreaChart,
  ResponsiveContainer,
  Legend,
} from "recharts";
import { Container, Button, Row, Col, Form } from "react-bootstrap";

const SIPCalculatorChart = () => {
  const [monthlyInvestment, setMonthlyInvestment] = useState(100000);
  const [years, setYears] = useState(20);
  const [rate, setRate] = useState(18);

  const calculateData = () => {
    let data = [];
    let totalInvested = 0;
    let futureValue = 0;
    const months = years * 12;
    const r = rate / 12 / 100;

    for (let i = 1; i <= months; i++) {
      totalInvested += monthlyInvestment;
      futureValue = (futureValue + monthlyInvestment) * (1 + r);
      if (i % 12 === 0) {
        data.push({
          year: i / 12,
          invested: totalInvested,
          value: futureValue,
        });
      }
    }

    return data;
  };

  const chartData = calculateData();

  return (
    <Container className="my-5">
      <h2 className="text-center text-primary mb-4">
        Check out the Power of SIP
      </h2>

      <Row className="mb-2 text-center">
        <Col>
          <Form.Label>Monthly Savings (₹)</Form.Label>
          <Form.Control
            type="number"
            value={monthlyInvestment}
            onChange={(e) => setMonthlyInvestment(Number(e.target.value))}
          />
        </Col>

        <Col>
          <Form.Label>Investment Period (Years)</Form.Label>
          <Form.Select
            value={years}
            onChange={(e) => setYears(Number(e.target.value))}
          >
            {[...Array(31).keys()].slice(1).map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </Form.Select>
        </Col>

        <Col>
          <Form.Label>Annual Return (%)</Form.Label>
          <div className="d-flex justify-content-center gap-2">
            {[8, 12, 15, 18, 21].map((val) => (
              <Button
                key={val}
                variant={val === rate ? "primary" : "outline-primary"}
                onClick={() => setRate(val)}
              >
                {val}%
              </Button>
            ))}
          </div>
        </Col>
      </Row>

      <ResponsiveContainer width="100%" height={400}>
      <AreaChart
        data={chartData}
        margin={{ top: 20, right: 30, left: 30, bottom: 20 }}
    >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="year" label={{ value: "Period in Years", position: "insideBottom", offset: -5 }} />
          <YAxis
            label={{
                value: "Amount (in ₹ Crores)",
                angle: -90,
                position: "insideLeft",
                offset: -5,
                style: { textAnchor: "middle", fill: "#666" },
            }}
            tickFormatter={(val) =>
                `₹${(val / 10000000).toFixed(1)} Cr`
            }
            />
          <Tooltip formatter={(value) => `₹${value.toFixed(0)}`} />
          <Area type="monotone" dataKey="invested" stackId="1" stroke="#ffc107" fill="#ffe082" />
          <Area type="monotone" dataKey="value" stackId="1" stroke="#28a745" fill="#c8e6c9" />
        </AreaChart>
        <Legend
            verticalAlign="top"
            formatter={(value) => {
                if (value === "total") return "Final Value";
                if (value === "invested") return "Amount Invested";
                return value;
            }}
        />
      </ResponsiveContainer>

      <div className="text-center mt-4 fs-3">
        An investment of{" "}
        <strong className="text-danger">₹{monthlyInvestment.toLocaleString("en-IN")}</strong> / month
        over <strong>{years}</strong> years at an ROI of <strong className="text-danger">{rate}%</strong>
        <br />
        grows to{" "}
        <strong className="text-success">
          ₹{chartData[chartData.length - 1]?.value.toLocaleString("en-IN")}
        </strong>
        .
      </div>
    </Container>
  );
};

export default SIPCalculatorChart;
